import { FormattedNumber } from 'react-intl'
import { MoreForLessEffectEditor } from '..'
import { Bag } from './Bag'
import styles from './styles'

const MAX_SUPPORTED_ITEMS_FOR_ILLUSTRATION = 10

type IllustrationProps = {
  config: MoreForLessEffectEditor
}

export function Illustration(props: IllustrationProps) {
  const {
    config: {
      trigger: { minQuantity = 0 },
      benefit: { quantity = 0 },
    },
  } = props

  const bagsQuantity = Math.max(
    0,
    Math.min(minQuantity, MAX_SUPPORTED_ITEMS_FOR_ILLUSTRATION)
  )

  const allBagsVisible = minQuantity <= MAX_SUPPORTED_ITEMS_FOR_ILLUSTRATION

  return (
    <div className={styles.bagsContainer} hidden={minQuantity < 1}>
      {Array(bagsQuantity)
        .fill(0)
        .map((_, index) => (
          <Bag key={index} highlighted={index < quantity} />
        ))}

      <div className="moreItemsTag" hidden={allBagsVisible}>
        <FormattedNumber
          value={minQuantity - MAX_SUPPORTED_ITEMS_FOR_ILLUSTRATION}
          signDisplay="always"
        />
      </div>
    </div>
  )
}
